import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  emailForm: FormGroup;
  passForm: FormGroup;
  alert: string;
  isNewPassword: boolean;
  randomValue: string;

  constructor(
    private _userService: UserService,
    private router: Router
  ) { }

  ngOnInit() {
     setInterval(()=>{
       this.randomValue = 'field_' + Math.random() ;
     },100);

    this.emailForm = new FormGroup({
      'email': new FormControl('', [Validators.required, Validators.email]),
      });
    this.passForm = new FormGroup({
      'token': new FormControl(''),
      'password1': new FormControl('', [Validators.minLength(8), Validators.pattern('^(?=.?[A-Z])(?=.?[a-z])(?=.*?[0-9]).{8,}$')]),
      'password2': new FormControl('', [Validators.minLength(8), Validators.pattern('^(?=.?[A-Z])(?=.?[a-z])(?=.*?[0-9]).{8,}$')])
    });
  }

  submitEmail() {
    if (this.emailForm.valid) {
      this._userService.forgot(this.emailForm.value).toPromise().then(
        (response: any) => {
          switch (response.error) {
            case 0:
              this.isNewPassword = true;
              this.passForm.value.token = null;
              this.passForm.value.password1 = null;
              this.passForm.value.password2 = null;
              break;
            case 1:
              this.alert = response.data;
              break;
            default:
              this.alert = 'Ocurrió un error';
              break;
          }
        },
        (error) => {
          this.alert = 'Ocurrió un error';
        }
      );
    }
  }
  submitPass() {
    if (this.passForm.valid) {
      if (this.passForm.value.password1 === '' ) {
        this.alert = 'Debe ingresar una contraseña';
        return;
      } else if (!(this.passForm.value.password1 === this.passForm.value.password2)) {
        this.alert = 'Las contraseñas no coinciden.';
        return;
      } else {
        this._userService.reset(this.passForm.value).toPromise().then(
          (response: any) => {
            switch (response.error) {
              case 0:
                this.router.navigate(['login']);
                break;
              case 1:
                this.alert = response.data;
                break;
              default:
                this.alert = 'Ocurrió un error';
                break;
            }
          },
          (error) => {
            this.alert = 'Ocurrió un error';
          }
        );
      }
    }
  }
}

